<template>
  <div v-if="menuData.isVisible">
    <q-btn
      data-cy="btnOpenMenu"
      flat
      round
      dense
      @click="isOpen = !isOpen"
      :icon="isOpen ? 'close' : 'menu'"
      class="q-mr-sm"
    />
    <q-drawer
      side="left"
      v-model="isOpen"
      :width="200"
      :breakpoint="500"
      bordered
      class="bg-grey-3 menuDrawer"
    >
      <q-scroll-area class="fit">
        <q-list class="text-primary listItems">
          <div v-for="(items, key) in menuData.data" :key="key">
            <span v-if="!items.items">
              <q-item
                style="margin-top: 5px; margin-bottom: 5px;"
                data-cy="itemMenu"
                clickable
                v-ripple
                :class="[
                  'title-menu-section text-center',
                  items.disabled ? 'disabled' : ''
                ]"
                :key="key"
                :to="
                  items.link !== undefined && !items.disabled
                    ? _getLink(items.link)
                    : ''
                "
              >
                <q-item-section avatar v-if="items.avatar.enabled">
                  <q-icon
                    :class="items.avatar.class"
                    :size="items.avatar.size"
                    :name="'img:' + require('@/assets/' + items.avatar.link)"
                  />
                </q-item-section>
                <q-item-section side class="text-label-item">{{
                  items.parentTitle
                }}</q-item-section>
              </q-item>
            </span>

            <q-expansion-item v-else dense-toggle :default-opened="isCiudadano" :label="items.parentTitle" :class="['title-menu-section text-center']">
              <div v-for="(item, key) in items.items" :key="key" class="text-label-item">
              <span v-if="!item.items">
              <q-item
                data-cy="itemMenu"
                clickable
                v-ripple
                :class="[
                  item.disabled ? 'disabled' : '',
                  _checkActualPage(item) ? 'active-item' : '',
                ]"
                :key="key"
                :to="
                  item.link !== undefined && !item.disabled
                    ? _getLink(item.link)
                    : ''
                "
                :href="item.href && !item.disabled? item.href: undefined"
                :target="item.href !== undefined? '_blank': ''"
              >
                <q-item-section avatar>
                  <q-icon
                    v-if="item.avatar.enabled"
                    :class="item.avatar.class"
                    :size="item.avatar.size"
                    :name="'img:' + require('@/assets/' + item.avatar.link)"
                  />
                </q-item-section>
                <q-item-section side class="text-label-item">{{
                  item.name
                }}</q-item-section>
              </q-item>
              </span>

              <q-expansion-item
                v-else
                dense-toggle
                default-opened
                :label="item.name"
                :class="[
                    item.disabled ? 'disabled' : '',
                    _checkActualPage(item) ? 'active-item' : '',
                  ]"
                :to="item.link !== undefined && !item.disabled ? _getLink(item.link): ''"
                :href="item.href && !item.disabled? item.href: undefined"
                :target="item.href !== undefined? '_blank': ''"
                :icon="'img:' + require('@/assets/' + item.avatar.link)"
              >
                <q-item
                clickable
                v-ripple
                v-for="(item, key) in item.items"
                :key="key"
                :class="[
                    item.disabled ? 'disabled' : '',
                    _checkActualPage(item) ? 'active-item' : '',
                  ]"
                :to="item.link !== undefined && !item.disabled ? _getLink(item.link): ''"
                :href="item.href && !item.disabled? item.href: undefined"
                :target="item.href !== undefined? '_blank': ''"
              >
              <q-item-section avatar>
                  <q-icon
                    v-if="item.avatar.enabled"
                    :class="item.avatar.class"
                    :size="item.avatar.size"
                    :name="'img:' + require('@/assets/' + item.avatar.link)"
                  />
                </q-item-section>
                <q-item-section side class="text-label-item">{{
                  item.name
                }}</q-item-section>
              </q-item>
              </q-expansion-item>
              </div>
            </q-expansion-item>
            <q-separator id="separator" spaced />
          </div>
        </q-list>
      </q-scroll-area>
    </q-drawer>
  </div>
</template>
<script>
import { QIcon, QScrollArea, QDrawer } from 'quasar';
import { mapGetters } from 'vuex';

export default {
  components: {
    QIcon,
    QScrollArea,
    QDrawer
  },
  data () {
    return {
      isOpen: false,
      menuData: {}
    };
  },
  props: {
    navigationMenu: {
      type: Object,
      default: function () {
        return {
          isVisible: true,
          data: [
            {
              name: 'Text to show',
              avatar: {
                // Show avatar?
                enabled: true,
                // Path from assets
                link: 'img/inbox.svg',
                size: '24px',
                class: 'imgCenter'
              },
              link: {
                type: 'name', // name, internal
                path: 'catalogo'
              }
            }
          ]
        };
      }
    }
  },
  computed: {
    ...mapGetters({
      isAdmin: 'NGUD/isAdmin',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  methods: {
    _checkActualPage (i) {
      if (i.link !== undefined) {
        let hasParams = false;
        hasParams = Object.keys(this.$route.query).length > 0;

        if (hasParams) {
          return this.$route.fullPath === i.link.path;
        }

        return this.$route.name === i.link.path;
      }
    },
    _getLink (object) {
      let link = '';

      switch (object.type) {
        case 'name':
          link = { name: object.path };
          break;
        case 'internal':
        default:
          link = object.path;
          break;
      }

      return link;
    },
    _checkPerms (data) {
      let dataMenu = data.data;

      if (dataMenu.length === 0) return;

      dataMenu.map((e, pos) => {
        if (e.needRol === 'Admin') { if (!this.isAdmin) { dataMenu.splice(pos, 1); } }
        if (e.needRol === 'AdminGestorOrAccess') { if (this.isCiudadano) { dataMenu.splice(pos, 1); } }
        if (e.needRol === 'Ciudadano') { if (!this.isCiudadano) { dataMenu.splice(pos, 1); } }
      });

      data.data = dataMenu;

      return data;
    }
  },
  watch: {
    navigationMenu: {
      handler: function () {
        if (Object.entries(this.navigationMenu).length > 0) {
          this.menuData = this._checkPerms(this.navigationMenu);
        }
      },
      immediate: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/css/style.scss";

a {
  text-align: left;
}
.menuDrawer {
  &::v-deep {
    .q-drawer {
      height: 100vh !important;
    }
    .q-item__section--side .q-icon > img {
      font-size: 30px !important;
    }
  }
}

#separator {
  margin: 0px !important;
}

a.q-item.q-item-type{
  margin-top: 5px !important;
}
</style>
